import { useState, useEffect } from "react";

const useInsigneCoins = () => {
    const [insigneCoins, setInsigneCoins] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const API_URL = process.env.REACT_APP_API;
    const userFunction = process.env.REACT_APP_USER_FUNCTION;
    const prefix = 'api/usuario-editora';
    const posfix = '-usuario-editora';
    const [token, setToken] = useState(localStorage.getItem('token' + userFunction)); // Track token changes

    const fetchInsigneCoins = async () => {
        if (token) { // Only fetch data if token exists (user is logged in)
            try {
                const response = await fetch(API_URL + prefix + '/coins' + posfix, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + token,
                    },
                });
                if (!response.ok) {
                    throw new Error("Erro ao obter os dados do perfil.");
                }
                const data = await response.json();
                setInsigneCoins(data);
                setLoading(false);
            } catch (error) {
                setError(error.message);
                setLoading(false);
            }
        } else {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchInsigneCoins();
    }, [token]); 

    return { insigneCoins, setInsigneCoins, loading, error};
};

export default useInsigneCoins;
